
export class icaoccModel{

  constructor( countryname : string, fips : string, icaocode : string, iso2code : string){
    this.countryname = countryname;
    this.fips = fips;
    this.icaocode = icaocode;
    this.iso2code = iso2code;
  }

  id: number;
  countryname: string;
  fips: string;
  icaocode: string;
  iso2code: string;
  isecacenp : boolean;
}
